import { FC } from 'react';

import { CircleCheck, CircleX, Info, TriangleAlert } from 'lucide-react';
import { ToastContainer as Toastify, ToastContainerProps as ToastifyProps } from 'react-toastify';

import { ThemesType } from '@/types/theme';

interface ToastContainerProps extends ToastifyProps {
  theme: ThemesType;
}

export const ToastContainer: FC<ToastContainerProps> = props => {
  const contextClass = {
    success: 'border-green-600 text-green-600',
    error: 'border-red-700 text-red-700',
    info: 'bg-background border-blue-600 text-blue-600',
    warning: 'border-yellow-500 text-yellow-500',
    default: 'border-input',
  };

  return (
    <Toastify
      position="top-center"
      autoClose={false}
      closeButton={false}
      newestOnTop={false}
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      draggable
      stacked
      toastClassName={context =>
        contextClass[context?.type || 'default'] +
        ' bg-background flex items-center gap-1.5 bg-background border rounded-lg text-sm font-medium overflow-hidden cursor-pointer w-auto p-4'
      }
      icon={({ type, theme: _theme }) => {
        switch (type) {
          case 'info':
            return <Info className="h-4 w-4 stroke-blue-600" />;
          case 'error':
            return <CircleX className="h-4 w-4 stroke-red-700" />;
          case 'success':
            return <CircleCheck className="h-4 w-4 stroke-green-600" />;
          case 'warning':
            return <TriangleAlert className="h-4 w-4 stroke-yellow-500" />;
          default:
            return null;
        }
      }}
      {...props}
    />
  );
};
